import $
	from 'jquery';

export const eventClickPauActions = ( e ) => {

	if ( e.target.id.indexOf( 'selector' ) !== -1 ) {
		return;
	}

	e.preventDefault();

	let $pauMainAcces    = $( "#pauMainAcces" ),
		dataUrl          = $pauMainAcces.attr( "data-url" ),
		mediaDirHeader   = dataUrl + "multimedia/pau/react/header/",
		$pauBackMain     = $( '#pauBackMain' ),
		$iconPauAcces    = $( '.iconPauAcces' ),
		$iconPauAccesimg = $( '.iconPauAcces img' ),
		$pauReactMenus   = $( '.pauReactMenus li a img' ),
		$panelActions    = $( '.panelActions > div' ),
		$pauContMain     = $( '#pauContMain' ),
		$pauContPanel    = $( '#pauContPanel' ),
		pauContMain      = parseInt( $pauContMain.attr( "data-value" ), 10 ),
		pauContPanel     = parseInt( $pauContPanel.attr( "data-value" ), 10 ),
		$target          = $( e.currentTarget ),
		dataKey          = $target.attr( "data-key" );

	// console.log( dataKey );

	switch ( dataKey ) {

		case "iconPauAcces" :

			$pauReactMenus.parent().removeClass( "active" );

			if ( pauContMain === 1 ) {

				$target.parent().addClass( 'pauPanelDesplegado' );

				$pauMainAcces
					.css( 'height', 'calc( 100% - 30px )' )
					.animate( {
						right : '-380px'
					} );

				$iconPauAcces.css( {
					"width"      : "80px",
					"height"     : "80px",
					"padding"    : "5px",
					"background" : "#010066"
				} );

				$target.parent().html( e.data.ico_pau );

				// $iconPauAccesimg.attr( "src", mediaDirHeader + "ico-pau.svg" );

				$pauBackMain.show();

				$pauContMain.attr( "data-value", 0 );

			} else if ( pauContMain === 0 ) {

				$target.parent().removeClass( 'pauPanelDesplegado' );

				$pauContMain.attr( "data-value", 1 );

				$pauMainAcces
					.css( 'height', '80px' )
					.animate( {
						right : '-450px'
					} );

				$iconPauAcces.css( {
					"width"      : "80px",
					"height"     : "80px",
					"padding"    : "0",
					"background" : "transparent"
				} );

				$target.parent().html( e.data.ico_principal_pau );

				// $iconPauAccesimg.attr( "src", mediaDirHeader + "ico-principal-pau.svg" );

				$pauBackMain.hide();

			}

			break;

		case "pauReactMenus" :

			$target = $( e.target );

			if ( pauContPanel === 1 ) {

				$pauMainAcces.animate( {
					right : '0'
				} );

				$pauContMain.attr( "data-value", 0 );

			}

			$pauReactMenus.parent().removeClass( "active" );

			let target = "";

			/*if ( $target.get(0).tagName === "A" ) {
			 target = $target.attr( "href" );
			 $target.addClass( "active" );
			 } else {
			 target = $target.parent().attr( "href" );
			 $target.parent().addClass( "active" );
			 }*/

			target = $target.parent().attr( "href" );
			$target.parent().addClass( "active" );

			$panelActions.hide();
			// console.log( $panelActions );
			$( target ).show();

			break;

		case "pauBackMain" :

			$pauReactMenus.parent().removeClass( "active" );

			pauContMain = 1;

			$pauBackMain.hide();

			$pauMainAcces.animate( {
				right : '-430px'
			} );

			break;

	}

};



// WEBPACK FOOTER //
// ./src/assets/js/MenuPauPrincipal.js